// Lib
import { curry } from 'lodash/fp';

export default curry((interval: number, threshold: number, value: number) => {
    const remainder = value % interval;

    // Snap down
    if (remainder < threshold) {
        return value - remainder;
    }

    // Snap up
    if (remainder > interval - threshold) {
        return value + interval - remainder;
    }

    // By default don't snap
    return value;
});
